// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__oPE0c","noPosts":"Dashboard_noPosts__pb38K","postHeader":"Dashboard_postHeader__SfAEl","postRow":"Dashboard_postRow__TbRJT"};